import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { getFilterContractTypes } from "../../../actions/contract-type-actions";
import ContractTypeAccordion from "./contractTypeAccordion";
import ContractTypeSearch from "./contractTypeSearch";
import Search from "../../../images/icons/search.svg";
import { useStateValue } from "../../../context/store";
import { headers } from "./models";
import ModalConfirmBaseComment from "../../../utils/form/modalConfirmBaseComment";
import ModalConfirmBase from "../../../utils/form/modalConfirmBase";
import { Backdrop, CircularProgress, Typography } from "@material-ui/core";
import Utils from "../../../utils/utils";
import { permissionsConstans } from "../../../constansPermissions";
import ContractTypeForm from "./contractTypeForm";
import _ from "lodash";

const ContractTypes = (props) => {
  const [{ filterContractType, breadCrumb }, dispatch] = useStateValue();
  const [isLoading, setIsLoading] = useState(false);
  const [permissionsTypeContract, setPermissionsTypeContract] = useState([]);
  const [contractTypes, setContractTypes] = useState([]);

  //const classes = styles();
  const [message, setMessage] = useState({
    open: false,
    question: "",
    handleClickOut: () => {},
    handleClick: () => {},
    buttonOneText: "",
    oneButtons: false,
    type: "",
  });

  const [confirm, setConfirm] = useState({
    open: false,
    question: "",
    handleClickOut: () => {},
    handleClick: () => {},
    buttonOneText: "",
    type: "",
    isCommentRequired: false,
  });

  const [filter, setFilter] = useState({
    contractType: null,
    status: null,
  });

  const formatData = (data) => {
    return data.map((contractType) => {
      contractType.initialDate =
        contractType.initialDate === true ? "Sí" : "No";
      contractType.endDate = contractType.endDate === true ? "Sí" : "No";
      contractType.notification =
        contractType.notification === true ? "Sí" : "No";
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getContractTypes = async () => {
    const response = await getFilterContractTypes(
      {
        status: filter.status === "" ? null : filter.status,
        contractType: filter.contractType === "" ? null : filter.contractType,
      },
      dispatch
    );
    if (response.data) {
      formatData(response.data);
      const contratTypeFormats = _.sortBy(
        response.data,
        function (contratTypeFormat) {
          return new Date(contratTypeFormat.creationDate);
        }
      ).reverse();
      setContractTypes(contratTypeFormats);
    } else {
      setContractTypes([]);
    }
  };

  useEffect(() => {
    const responsePersmissions = Utils.validationPermissions("FOR_TIP_CON");
    setPermissionsTypeContract(responsePersmissions);
    getContractTypes();
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Tipos de Contratos",
      breadCrumbSubText: "Contratos",
      index: 11,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (
    filterContractType &&
    filterContractType?.isFilter &&
    filter !== filterContractType.filter
  ) {
    var newfilter = filterContractType.filter;
    filter.contractType = newfilter.contractType;
    filter.status = newfilter.status;
    getContractTypes();
    dispatch({
      type: "SET_CONTRACT_TYPE_FILTER",
      isFilter: false,
    });
  }

  const toggleCreateForm = () => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Tipos de Contratos",
      breadCrumbSubText: "Tipos de Contratos",
      index: 11,
      open: false,
    });
  };

  const permissionCreateTypeContract = () => {
    if (
      permissionsTypeContract?.functionalities?.some(
        (x) => x === permissionsConstans.FOR_TIP_CON_CREAR
      )
    ) {
      return breadCrumb?.open;
    }
  };

  const permissionSearchTypeContract = () => {
    if (
      permissionsTypeContract?.functionalities?.some(
        (x) => x === permissionsConstans.FOR_TIP_CON_CONSULTAR
      )
    ) {
      return <ContractTypeSearch />;
    }
  };

  return (
    <div style={{ marginTop: "25px" }}>
      <ModalConfirmBase
        open={message.open}
        description={message.question}
        handleClickOut={message.handleClickOut}
        handleClick={message.handleClick}
        oneButtons={message.oneButtons}
        textButtonSubmit={message.buttonOneText}
        type={message.type}
      />
      <ModalConfirmBaseComment
        open={confirm.open}
        description={confirm.question}
        handleClickOut={confirm.handleClickOut}
        handleClick={confirm.handleClick}
        textButtonSubmit={confirm.buttonOneText}
        type="QUESTION"
        isCommentRequired={confirm.isCommentRequired}
      />
      {permissionSearchTypeContract()}
      {breadCrumb?.open && (
        <ContractTypeForm
          showCreateForm={breadCrumb?.open}
          toggleCreateForm={toggleCreateForm}
          toggleForm={toggleCreateForm}
        />
      )}

      {contractTypes.length > 0 ? (
        contractTypes.map((row, index) => (
          <ContractTypeAccordion
            style={{ marginTop: "10px" }}
            headers={headers}
            data={row}
            permissionsRequisition={permissionsTypeContract}
            permissionsConstans={permissionsConstans}
          />
        ))
      ) : (
        <div>
          <div
            style={{
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "10%",
              display: "flex",
            }}
          >
            <img src={Search} alt="" />
            <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
              No se encontraron registros que coincidan con el filtro de
              búsqueda aplicado.
            </Typography>
          </div>
        </div>
      )}
      <Backdrop style={{ zIndex: "9999" }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default withRouter(ContractTypes);
